import React from 'react';
import { MessageCircle, Search, Target, PresentationIcon } from 'lucide-react';

export const ProcessSection = () => {
  const steps = [
    {
      number: "01",
      icon: MessageCircle,
      title: "Cadrage",
      description: "Un échange avec le dirigeant permet de comprendre les priorités commerciales, les offres stratégiques, les clients recherchés et les difficultés déjà constatées."
    },
    {
      number: "02",
      icon: Search,
      title: "Analyse",
      description: "Étude des principaux points de contact utiles : site, messages, supports commerciaux, identité, parcours de prise de contact et autres éléments convenus."
    },
    {
      number: "03",
      icon: Target,
      title: "Diagnostic",
      description: "Identification des écarts entre : ce que l'entreprise souhaite faire comprendre ; ce qu'elle montre réellement ; ce que ses prospects cherchent à vérifier avant de décider."
    },
    {
      number: "04",
      icon: PresentationIcon,
      title: "Restitution",
      description: "Présentation des écarts prioritaires, de leurs conséquences possibles et du plan d'action recommandé."
    }
  ];

  return (
    <section id="deroulement" className="py-32 bg-white relative">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto fade-in-section">
          <h2 className="section-title mb-16 text-center">
            Comment se déroule<br />
            le <span className="text-accent">Gap de Perception</span> ?
          </h2>

          <div className="space-y-8">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="flex flex-col md:flex-row gap-6 items-start p-8 bg-gray-50 rounded-lg border border-gray-200 hover:border-accent transition-all"
              >
                <div className="flex flex-col items-center gap-3 min-w-[100px]">
                  <span className="text-5xl font-bold text-gray-200" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {step.number}
                  </span>
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center border-2 border-accent">
                    <step.icon className="h-7 w-7 text-accent" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed text-lg">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 p-6 bg-gray-100 rounded-lg text-center">
            <p className="text-gray-700 italic">
              Les détails opérationnels (nombre d'entretiens, durée, volume du livrable) seront précisés lors du cadrage initial en fonction de votre situation spécifique.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
